import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import NoInternetIcon from "assets/svgs/noInternetWarning.svg";
import "./NoInternetModal.scss";
import { SpinnerNoInternet } from "shared/components/index";
import { useTranslation } from 'react-i18next';

const NoInternetModal = () => {
  const { t } = useTranslation();
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);

    globalThis.addEventListener("online", handleOnline);
    globalThis.addEventListener("offline", handleOffline);

    return () => {
      globalThis.removeEventListener("online", handleOnline);
      globalThis.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <Modal isOpen={true} className="no-internet-container">
      <div>
        <NoInternetIcon />
      </div>
      <div className="no-internet-title">
        {t("common.messages.noInternet.title")}
      </div>
      <div className="no-internet-desc">
        {t("common.messages.noInternet.desc")}
      </div>
      <div className="no-internet-reconnecting">
        <SpinnerNoInternet speedMultiplier={5} spinnerSize={24} />
      </div>
    </Modal>
  );
};

export default NoInternetModal;
